<template>
  <div class="ws-read-content-block">
    <WsCard v-if="type == 'infoCard'">
      <WsContent v-for="(floor, floorKey) in floors" :key="floorKey">
        <WsContentTitle v-if="floor.title">{{ floor.title }}</WsContentTitle>
        <WsContentRemark v-if="floor.remark">{{ floor.remark }}</WsContentRemark>
        <WsInfo
          v-for="(fieldKey, fieldIndex) in floor.fields"
          :key="fieldIndex"
          :locale="locale"
          :label="$_CMS_getLabelByHideLabelFields(fieldKey, modedFields, floor.hideLabelFields)"
          :type="$_CMS_getFieldByFieldKey(fieldKey, modedFields).type"
          :fields="$_CMS_getFieldByFieldKey(fieldKey, modedFields).fields"
          :items="$_CMS_getFieldByFieldKey(fieldKey, modedFields).items"
          :textKey="$_CMS_getFieldByFieldKey(fieldKey, modedFields).textKey"
          :valueKey="$_CMS_getFieldByFieldKey(fieldKey, modedFields).valueKey"
          :getText="$_CMS_getFieldByFieldKey(fieldKey, modedFields).getText"
          :maxWidth="$_CMS_getFieldByFieldKey(fieldKey, modedFields).maxWidth"
          :getValue="$_CMS_getFieldByFieldKey(fieldKey, modedFields).getValue"
          :displayLabel="$_CMS_getFieldByFieldKey(fieldKey, modedFields).displayLabel"
          :originData="modelData"
          :activeText="$_CMS_getFieldByFieldKey(fieldKey, modedFields).activeText"
          :inactiveText="$_CMS_getFieldByFieldKey(fieldKey, modedFields).inactiveText"
          :multiple="$_CMS_getFieldByFieldKey(fieldKey, modedFields).multiple"
          :value="$_CMS_getValueByFieldKey(fieldKey, modelData)"
          :displayCheck="$_CMS_getFieldByFieldKey(fieldKey, modedFields).displayCheck"
          :hideOnNull="hideOnNull"
        ></WsInfo>
      </WsContent>
    </WsCard>
    <WsReadTab
      v-else-if="type === 'tabs'"
      :tabSetting="tabSetting"
      :tabItems="tabItems"
      :modelData="modelData"
      @create-btn-click="$emit('create-btn-click')"
      @tab-click="$emit('tab-click', $event)"
    ></WsReadTab>
    <WsDataExpandList
      v-else-if="type == 'expandList'"
      ref="wsDataExpandList"
      :modelName="modelName"
      :label="label"
      :parentModelName="parentModelName"
      :parentState="parentState"
      :locale="locale"
      :fields="fields"
      :titleKey="titleKey"
      :searchMode="searchMode"
      :batchMode="batchMode"
      :fieldsRead="fieldsRead"
      :modeVersions="modeVersions"
      :rootModelName="rootModelName"
      :modelData="modelData"
      :orderBy="orderBy"
      :orderWay="orderWay"
      :hideOnNull="hideOnNull"
      :filterSelects="filterSelects"
      :showExpand="showExpand"
      :showFields="showFields"
      :createVersion="createVersion"
      :itemVersionCreatable="itemVersionCreatable"
      :itemVersionLinkCreatable="itemVersionLinkCreatable"
      :itemVersionReadable="itemVersionReadable"
      :itemDeletable="itemDeletable"
      :itemEditable="itemEditable"
      :itemLinkCheckable="itemLinkCheckable"
      :params="params"
      :postData="postData"
      :sequenceFields="sequenceFields"
      :isGetAll="isGetAll"
      :modelVersionName="modelVersionName"
      :hasSequence="hasSequence"
      :hasChapters="hasChapters"
      :hasCatchVersion="hasCatchVersion"
      :customParentData="_customParentData"
      :expandDisable="expandDisable"
      :filterName="filterName"
      :filterSubName="filterSubName"
      :isVersionAPI="isVersionAPI"
      :itemVersionReadableUrl="itemVersionReadableUrl"
      :virtualScroll="virtualScroll"
      :batchLink="batchLink"
      :itemLinkEditable="itemLinkEditable"
      :itemCreateBtnEmitAble="itemCreateBtnEmitAble"
      :customBtns="customBtns"
      :versionModelName="versionModelName"
      :staticModelData="staticModelData"
      :customCreateAction="customCreateAction"
      :customUpdateAction="customUpdateAction"
      :defaultBtnDisplayFunc="defaultBtnDisplayFunc"
      :customUpdateSubmitAction="customUpdateSubmitAction"
      :customCreateSubmitAction="customCreateSubmitAction"
      :itemCreatable="itemCreatable"
      :shouldShowUpdateTag="shouldShowUpdateTag"
      :getUrl="getUrl"
      :isBatchCreateMultiLangAble="isBatchCreateMultiLangAble"
      :batchCreateMultiLangLink="batchCreateMultiLangLink"
      @created="$_onCreated($event)"
      @deleted="$_onDeleted($event)"
      @create-btn-click="$emit('create-btn-click')"
      @custom-event="$_onCustomEvent($event)"
    ></WsDataExpandList>
    <WsDataExpandSystemClass
      v-else-if="type == 'expandSystemClass'"
      ref="wsDataExpandList"
      :modelName="modelName"
      :label="label"
      :parentModelName="parentModelName"
      :parentState="parentState"
      :locale="locale"
      :fields="fields"
      :titleKey="titleKey"
      :searchMode="searchMode"
      :batchMode="batchMode"
      :fieldsRead="fieldsRead"
      :modeVersions="modeVersions"
      :rootModelName="rootModelName"
      :modelData="modelData"
      :orderBy="orderBy"
      :orderWay="orderWay"
      :hideOnNull="hideOnNull"
      :filterSelects="filterSelects"
      :showExpand="showExpand"
      :showFields="showFields"
      :createVersion="createVersion"
      :itemVersionCreatable="itemVersionCreatable"
      :itemVersionLinkCreatable="itemVersionLinkCreatable"
      :itemVersionReadable="itemVersionReadable"
      :itemDeletable="itemDeletable"
      :itemEditable="itemEditable"
      :itemLinkCheckable="itemLinkCheckable"
      :params="params"
      :postData="postData"
      :sequenceFields="sequenceFields"
      :isGetAll="isGetAll"
      :modelVersionName="modelVersionName"
      :hasSequence="hasSequence"
      :hasChapters="hasChapters"
      :hasCatchVersion="hasCatchVersion"
      :customParentData="_customParentData"
      :expandDisable="expandDisable"
      :filterName="filterName"
      :filterSubName="filterSubName"
      :isVersionAPI="isVersionAPI"
      :itemVersionReadableUrl="itemVersionReadableUrl"
      @created="$_onCreated($event)"
      @deleted="$_onDeleted($event)"
    ></WsDataExpandSystemClass>
    <WsCard v-else-if="type == 'activeSwitch'">
      <WsContent>
        <WsContentTitle v-if="title">{{ title }}</WsContentTitle>
        <WsContentRemark v-if="remark">{{ remark }}</WsContentRemark>
        <WsLiveStateSwitch
          :value="$_CMS_getValueByFieldKey(field, modelData)"
          :field="field"
          :modelName="parentModelName"
          :modelId="modelId"
          :activeText="$_CMS_getFieldByFieldKey(field, modedFields).activeText"
          :inactiveText="$_CMS_getFieldByFieldKey(field, modedFields).inactiveText"
          :extendPatchData="extendPatchData"
          :modelData="modelData"
        ></WsLiveStateSwitch>
      </WsContent>
    </WsCard>
    <WsCard v-else-if="type == 'tagsEditor'">
      <WsContent>
        <WsContentTitle v-if="title">{{ title }}</WsContentTitle>
        <WsContentRemark v-if="remark">{{ remark }}</WsContentRemark>
        <WsLiveStateTags
          :value="$_CMS_getValueByFieldKey(field, modelData)"
          :field="field"
          :modelName="parentModelName"
          :modelId="modelId"
          :activeText="activeText"
          :inactiveText="inactiveText"
        ></WsLiveStateTags>
      </WsContent>
    </WsCard>
    <WsCard v-else-if="type == 'select'">
      <WsContent>
        <WsContentTitle v-if="title">{{ title }}</WsContentTitle>
        <WsContentRemark v-if="remark">{{ remark }}</WsContentRemark>
        <WsLiveStateSelect
          :value="$_CMS_getValueByFieldKey(field, modelData)"
          :field="field"
          :modelName="parentModelName"
          :modelId="modelId"
          :items="$_CMS_getFieldByFieldKey(field, modedFields).items"
        ></WsLiveStateSelect>
      </WsContent>
    </WsCard>
  </div>
</template>

<script>
export default {
  props: {
    activeText: {
      type: String,
      default: null,
    },
    inactiveText: {
      type: String,
      default: null,
    },
    orderBy: {
      type: String,
      default: 'sequence',
    },
    orderWay: {
      type: String,
      default: 'asc',
    },
    titleKey: {
      type: String,
      default: null,
    },
    modeVersions: {
      type: Boolean,
      default: false,
    },
    // parentIsBelongsToMany: {
    //   type: Boolean,
    //   default: false,
    // },
    // belongsToChapters: {
    //   type: Boolean,
    //   default: false,
    // },
    batchMode: {
      type: Boolean,
      default: false,
    },
    searchMode: {
      type: Boolean,
      default: false,
    },
    parentState: {
      type: [Number, String],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    remark: {
      type: String,
      default: null,
    },
    modelData: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      default: null,
    },
    fieldsRead: {
      type: Array,
      default: null,
    },
    modedFields: {
      type: Object,
      required: true,
    },
    field: {
      type: String,
      default: null,
    },
    fields: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: 'infoCard',
    },
    floors: {
      type: Array,
      default() {
        return [];
      },
    },
    parentModelName: {
      type: String,
      default: null,
    },
    modelId: {
      type: [Number, String],
      default: null,
    },
    modelName: String,
    modelTemplateName: {
      type: String,
      default: '',
    },
    modeParent: {
      type: Boolean,
      default: false,
    },
    customButtons: {
      type: Array,
      default: null,
    },
    subVersionFields: {
      type: Object,
      default() {
        return {};
      },
    },
    subVersionFieldsReads: {
      type: Array,
      default() {
        return [];
      },
    },
    rootModelName: {
      type: String,
      default: '',
    },
    hideOnNull: {
      type: Boolean,
      default: true,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showFields: {
      type: Array,
    },
    tabSetting: {
      type: Array,
    },
    multiTomulti: {
      type: Boolean,
      default: false,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    itemVersionCreatable: {
      type: Boolean,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
    },
    itemVersionReadable: {
      type: Boolean,
    },
    itemEditable: {
      type: Boolean,
    },
    itemDeletable: {
      type: Boolean,
    },
    itemLinkCheckable: {
      type: Boolean,
    },
    params: {
      type: Object,
    },
    postData: {
      type: Object,
    },
    sequenceFields: {
      type: Array,
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    virtualScroll: {
      type: Boolean,
      default: false,
    },
    modelVersionName: {
      type: String,
      default: '',
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Function,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    expandDisable: {
      type: Boolean,
      default: false,
    },
    filterName: {
      type: String,
    },
    filterSubName: {
      type: String,
    },
    isVersionAPI: {
      type: Boolean,
      default: false,
    },
    itemVersionReadableUrl: {
      type: Function,
    },
    batchLink: {
      type: Function,
    },
    itemLinkEditable: {
      type: Boolean,
      default: false,
    },
    tabItems: {
      type: Array,
    },
    itemCreateBtnEmitAble: {
      type: Boolean,
      default: false,
    },
    extendPatchData: {
      type: Function,
    },
    customBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    versionModelName: {
      type: String,
      default: '',
    },
    staticModelData: {
      type: Function,
    },
    customCreateAction: {
      type: Function,
    },
    customUpdateAction: {
      type: Function,
    },
    defaultBtnDisplayFunc: {
      type: Function,
    },
    customUpdateSubmitAction: {
      type: Function,
    },
    customCreateSubmitAction: {
      type: Function,
    },
    itemCreatable: {
      type: Boolean,
      default: true,
    },
    shouldShowUpdateTag: {
      type: Function,
    },
    getUrl: {
      type: Function,
    },
    isBatchCreateMultiLangAble: {
      type: Boolean,
      default: false,
    },
    batchCreateMultiLangLink: {
      type: Function,
    },
  },
  methods: {
    $_onCreated($event) {
      this.$emit('created', $event);
    },
    $_onDeleted($event) {
      this.$emit('deleted', $event);
    },
    $_onCustomEvent($event) {
      this.$emit('custom-event', $event);
    },
  },
  computed: {
    _customParentData() {
      if (this.customParentData) {
        return this.customParentData(this.modelData);
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
</style>
